import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { CanLoad, Route, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs';
import { RegistrationService } from '../../services/registration.service';

@Injectable()
export class AdminauthGuard implements CanActivate {

  constructor(private auth: RegistrationService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    
    if (this.auth.isAdminLoggedIn()) {
      // console.log('Admin Authenticated');
      return true;
    } else {
      // console.log('Admin Is Not Authenticated');
      this.router.navigate(['adminlogin']); // Redirect to login page if not authenticated
      return false;
    }
  }

  // canLoad(
  //   route: Route,
  // ): Observable<boolean> | Promise<boolean> | boolean {
    
  //   if (this.auth.isAdminLoggedIn()) {
  //     console.log('Admin Authenticated');
  //     return true;
  //   } else {
  //     console.log('Admin Is Not Authenticated');
  //     this.router.navigate(['/adminlogin']);
  //     return false;
  //   }
  // }

}



// WEBPACK FOOTER //
// ./src/app/admin/adminauth/adminauth.guard.ts